
import React, { useEffect, useState } from "react"
import FormDesktop from "./FormDesktop"
import FormMobile from "./FormMobile"
import { useMediaQuery } from "react-responsive"
import { FormProps } from "@/app/interface/components"

const Form: React.FC<FormProps> = ({ consorcio=false, financing=false, about=false, support=false, parts=false }) => {
    const isDesktop = useMediaQuery({ minWidth: 1140 })
    const [isMounted, setIsMounted] = useState(false)

    useEffect(() => {
        setIsMounted(true)
    }, [])

    // Renderiza nulo até que o componente esteja montado para evitar problemas de hidratação
    if (!isMounted) {
        return null
    }

    return (
        <>
            {isDesktop ? (
                <FormDesktop consorcio={consorcio} financing={financing} about={about} support={support} parts={parts} />
            ) : (
                <FormMobile consorcio={consorcio} financing={financing} about={about} support={support} parts={parts} />
            )}
        </>
    )
}

export default Form
